import * as React from "react";
import { useState } from "react";
import { RoleType } from "../../../../../../../../Wrap/Constants/Enums/RoleType";
import { Urls } from "../../../../../../Urls";
import { roleTypeMap } from "../../../../ClientRecord/Resource/Contents";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { EyeIcon } from "../../../../../../../Shared/Process/Process/EyeIcon";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { AccountInformation } from "./AccountInfoPopUp/AccountInformation";
import { Lightbox } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import CoachMarker from "../../../../../../../Shared/CoachMarkers/CoachMarker";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { AccountInfoAction } from "../Action/AccountInfoAction";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { StaticUrls } from "../../../../../../Resoures/StaticUrls";
import { setActionMenuParams } from "../../../../../../../DLU/DLUHelper";
import { SideMenu } from "../../../../../../../../Wrap/Constants/Enums/Menu/SideMenu";

export const PortfolioClientRoleDiagram = (props: any) => {
    //processedHoldings- always keep the order individualHolding,jointHoldings,otherHoldings
    const isShowPopAccount = getQueryParameters()["showaccountinfo"];
    const isShowPop = !CommonHelper.isNullOrEmpty(isShowPopAccount);
    const defaultAccount = isShowPop
        ? props.roleDiagramConfig.holdings.find((ele) => ele.hierarchyId == isShowPopAccount)
        : null;

    const [lightbox, setLightbox] = useState(isShowPop);
    const [selectedAccount, setSelectedAccount] = useState(defaultAccount);

    const processedHoldings = [];
    const jointHoldings: any[] = [];
    const otherHoldings = [];
    const individualHolding = [];

    for (const holding of props.roleDiagramConfig.holdings) {
        if (holding.type == roleTypeMap[RoleType.IndividualAccountHolder]) {
            individualHolding.push(holding);
        } else if (holding.type == roleTypeMap[RoleType.JointAccountHolder]) {
            jointHoldings.push(holding);
        } else {
            otherHoldings.push(holding);
        }
    }

    if (individualHolding.length) {processedHoldings.push(...individualHolding);}
    if (jointHoldings.length) {processedHoldings.push(...jointHoldings);}
    if (otherHoldings.length) {processedHoldings.push(...otherHoldings);}

    const navigateToClientRecord = (customerId: number, isTrustEntity: boolean) => {
        if (isTrustEntity) {
            Navigator.navigateTo(
                Urls.get().main.PortfolioDashboard({
                    hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId),
                }).OrganisationDetails
            );
        } else {
            Navigator.navigateTo(
                Urls.get().main.PortfolioDashboard({
                    hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId),
                }).personalDetail
            );
        }
    };

    const checkCustomerIdAndNavigate = (holding: any, product: any) => {
        if (![RoleType.IndividualAccountHolder, RoleType.JointAccountHolder].includes(holding.roleTypeId)) {
            AccountInfoAction.getAccountRoles(holding.hierarchyId, (roles) => {
                const customer = (roles || []).find((role) => role.IsPrimary);
                if (customer) {
                    navigateToProductOverview(
                        customer.Customer?.HierarchyId,
                        product.hierarchyid,
                        product.type,
                        product.id
                    );
                }
            });
        } else {
            navigateToProductOverview(
                ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                product.hierarchyid,
                product.type,
                product.id
            );
        }
    };

    const navigateToProductOverview = (
        customerHierarchyid: string,
        subAccountHierarchyId: string,
        subAccountType: SubAccountType,
        clAccountId: string
    ) => {
        if (checkPermission(UserClaim.AdviserPortalClientInvestmentsCanView)) {
            if (subAccountType == SubAccountType.Sipp) {
                setActionMenuParams({
                    SideMenu: SideMenu.OldSipp,
                    subaccountHierarchyId: subAccountHierarchyId,
                    headaccounthierarchyId: null,
                    levelHierarchyId: customerHierarchyid,
                });
                window.location.assign(StaticUrls.SippDetail(clAccountId));
            } else {
                window.location.assign(
                    `/wpadviser/en-gb/dashboard/home/main/customer/${customerHierarchyid}/subaccount/${subAccountHierarchyId}/productoverview`
                );
            }
        }
    };

    const holdingsList = processedHoldings.map((holding: any, index) => (
        <li className="list-container " key={index}>
            {jointHoldings.length && individualHolding == holding && holding != undefined ? (
                <>
                    <span className="rd-node holding-container bind">
                        <span className="right-bind-line"></span>
                        <span className="bind-icon"></span>
                        <span className="left-bind-line"></span>
                        <span className="holding-type">
                            <b>{holding.type}</b>
                            <p className="mb-0">
                                {holding.type !== "Joint account holder" ? (
                                    holding.customerName
                                ) : checkPermission(UserClaim.AdviserPortalClientSummaryCanView) ? (
                                    <a
                                        className="hyperlink"
                                        onClick={() =>
                                            window.open(
                                                `/wpadviser/en-gb/dashboard/home/main/customer/${HierarchyIdHelper.toHierarchyIdString(
                                                    HierarchyLevelName.Customer,
                                                    holding.otherCustomerId
                                                )}/summary`
                                            )
                                        }
                                    >
                                        {holding.customerName}
                                    </a>
                                ) : (
                                    <span>{holding.customerName}</span>
                                )}
                            </p>
                        </span>
                        <br />
                        <span className={"holding-id" + (holding.interestedParty ? " interested-party" : "")}>
                            {holding.id}
                        </span>
                    </span>
                    <Permission userClaim={UserClaim.AdviserPortalAccountInfoCanView}>
                        <div className="row row-center mb-30">
                            <div className="col-12 col-md-6 col-equalise">
                                <button
                                    onClick={() => {
                                        setLightbox(true);
                                        setSelectedAccount(holding);
                                    }}
                                    className="eye-button"
                                >
                                    <EyeIcon />
                                    <span className="text">View account information</span>
                                </button>
                            </div>
                        </div>
                    </Permission>
                </>
            ) : (
                <>
                    <span className="rd-node holding-container">
                        <span className="holding-type">
                            <b>{holding.type}</b>
                            <p className="mb-0">
                                {holding.type !== "Joint account holder" ? (
                                    holding.customerName
                                ) : checkPermission(UserClaim.AdviserPortalClientSummaryCanView) ? (
                                    <a
                                        className="hyperlink"
                                        onClick={() =>
                                            window.open(
                                                `/wpadviser/en-gb/dashboard/home/main/customer/${HierarchyIdHelper.toHierarchyIdString(
                                                    HierarchyLevelName.Customer,
                                                    holding.otherCustomerId
                                                )}/summary`
                                            )
                                        }
                                    >
                                        {holding.customerName}
                                    </a>
                                ) : (
                                    <span>{holding.customerName}</span>
                                )}
                            </p>
                        </span>
                    </span>
                    <Permission userClaim={UserClaim.AdviserPortalAccountInfoCanView}>
                        <div className="row row-center mb-30">
                            <div className="col-equalise">
                                <button
                                    onClick={() => {
                                        if (
                                            holding.roleTypeId == RoleType.IndividualAccountHolder ||
                                            holding.roleTypeId == RoleType.JointAccountHolder ||
                                            holding.roleTypeId == RoleType.RegisteredContact
                                        ) {
                                            setLightbox(true);
                                            setSelectedAccount(holding);
                                        } else if (checkPermission(UserClaim.AdviserPortalAccountInfoCanView)) {
                                            window.location.assign(
                                                `/clients/clientdetails/clientdetails-accountinfo.aspx?claccountid=${holding.id}`
                                            );
                                        }
                                    }}
                                    className="eye-button"
                                >
                                    <EyeIcon />
                                    <span className="text">View account information</span>
                                </button>
                            </div>
                        </div>
                    </Permission>
                </>
            )}

            <ul className="product-list-container">
                <li key={holding.id} className="product-item">
                    <span>
                        <div className="product">
                            <span className="product-name">{holding.accountName}</span>
                            <br />
                            <span className="product-id"> {holding.id}</span>
                        </div>
                    </span>
                </li>
                {holding.products.map((product: any) => (
                    <li key={product.id} className="product-item has-link">
                        <button
                            className="hyperlink"
                            onClick={() =>
                                checkPermission(UserClaim.AdviserPortalClientInvestmentsCanView)
                                    ? checkCustomerIdAndNavigate(holding, product)
                                    : null
                            }
                        >
                            <div className="product">
                                <span className="product-name">{product.name}</span>
                                <br />
                                <span className="product-id"> {product.id}</span>
                            </div>
                        </button>
                    </li>
                ))}
            </ul>
        </li>
    ));

    return (
        <>
            {checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView) && (
                <div className="client-roles-diagram-wrap">
                    <ul className="client-roles-diagram is-scrollable">
                        <li>
                            <div className="top-section">
                                <button
                                    className="rd-client tree-node"
                                    onClick={() => {
                                        navigateToClientRecord(
                                            props.roleDiagramConfig.id,
                                            props.roleDiagramConfig.isTrustEntity
                                        );
                                    }}
                                >
                                    <span className="icon"></span>
                                    <CoachMarker coachMarkerKey="client-information" />
                                    <div className="rd-client-name">{props.roleDiagramConfig.subject}</div>
                                    <div className="rd-client-id">Client ID: {props.roleDiagramConfig.id}</div>
                                </button>
                            </div>
                            <ul className="rd-holding-list">{holdingsList}</ul>
                        </li>
                    </ul>
                </div>
            )}
            {lightbox && (
                <Lightbox
                    cssWrapper="is-default-lightbox is-wider"
                    show={lightbox}
                    onClose={() => setLightbox(false)}
                    title="Account information"
                >
                    <AccountInformation selectedAccount={selectedAccount} customerId={props.roleDiagramConfig.id} />
                </Lightbox>
            )}
        </>
    );
};
